import { EventAggregator } from 'aurelia-event-aggregator';
import { bindable, bindingMode, containerless } from 'aurelia-framework';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Models } from 'models/core';
import { ErrorService } from 'services/error-service';
import { PreparationRopeKnotPlacementService } from 'services/preparation-rope-knot-placement-service';
import { PreparationRopeKnotService } from 'services/preparation-rope-knot-service';
import { PreparationRopePlacementService } from 'services/preparation-rope-placement-service';
import { PreparationRopeService } from 'services/preparation-rope-service';
import { PreparationRopeTypeService } from 'services/preparation-rope-type-service';
import { RopeDimensionService } from 'services/rope-dimension-service';
import { RopeTypeService } from 'services/rope-type-service';
import { ToastService } from 'services/toast-service';

@containerless
@autoinject
export class PreparationRopeFormInlineNew {
  @bindable private netPreparationId: number;
  private preparationrope: Models.PreparationRope = new Models.PreparationRope();
  private currentRopeType: Models.RopeType;

  constructor(
    private errorService: ErrorService,
    private eventAggregator: EventAggregator,
    private preparationRopeKnotPlacementService: PreparationRopeKnotPlacementService,
    private preparationRopeKnotService: PreparationRopeKnotService,
    private preparationRopePlacementService: PreparationRopePlacementService,
    private preparationRopeService: PreparationRopeService,
    private preparationRopeTypeService: PreparationRopeTypeService,
    private ropeDimensionService: RopeDimensionService,
    private ropeTypeService: RopeTypeService,
    private router: Router,
    private toastService: ToastService
  ) { }

  private createPreparationRope() {
    this.preparationrope.NetPreparationId = this.netPreparationId;
    this.preparationRopeService
      .post(this.preparationrope)
      .then((res) => {
        this.eventAggregator.publish('preparationRopeListReset', 1);
        this.eventAggregator.publish('preparationRopeFormNewClose', 1);
        this.toastService.showSuccess('preparationrope.created');
        this.preparationrope = new Models.PreparationRope();
      })
      .catch((err) => this.errorService.handleError(err));
  }

  private getRopeTypes() {
    return this.ropeTypeService.getAllCached()
        .then((res) => {
          return res.filter((x) => x.NavisionProductId || x.DeltaProductId);
        });
  }

  private ropeTypeChanged(event) {
    if (!event.detail.value || event.detail.value === this.preparationrope.RopeTypeId) {
      return;
    }
    this.preparationrope.RopeTypeId = event.detail.value;
    this.ropeTypeService
      .get(this.preparationrope.RopeTypeId)
      .then((res) => {
        this.currentRopeType = res;
        this.preparationrope.RopeDimensionId = this.currentRopeType.RopeDimensionId;
      })
      .catch((err) => this.errorService.handleError(err));
  }

  private cancel() {
    this.eventAggregator.publish('preparationRopeFormNewClose', 1);
  }

}
